import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { Class, ClassTeacher } from '../data/class';
import { Router } from '@angular/router';

@Component({
  selector: 'app-class-list',
  templateUrl: './class-list.component.html',
  styleUrls: ['./class-list.component.css']
})
export class ClassListComponent extends BaseComponent implements OnInit {

  @Input() classes: Class[];
  @Input() noMatches: boolean;
  @Input() loading: boolean;

  getTeacherName(class_: Class): string {
    return (class_.TeacherName || '') + (class_.Teachers.length > 1 ? ' *' : '');
  }

  showMultipleTeacherHint = () => {
    return this.classes.some(c => c.Teachers.length > 1);
  }

  getRouterLink(class_: Class): string {
    return `/classes/${class_.ClassSectionID}/class/${class_.ID}`;
  }

  navigateToClass(class_: Class): any {
    this.router.navigateByUrl(this.getRouterLink(class_));
  }
}
